"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
function SvgTips(props) {
    return ((0, jsx_runtime_1.jsxs)("svg", __assign({ viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: [(0, jsx_runtime_1.jsx)("path", { clipRule: "evenodd", d: "M22.07 32c1.059 0 1.915-.86 1.92-1.92v0c0-5.76 6.01-7.68 6.01-13.44S25.004 8 20 8s-10 2.88-10 8.64c0 5.76 5.995 7.68 5.995 13.44v0a1.918 1.918 0 001.92 1.92h4.155z", stroke: "currentColor", strokeWidth: 2 }, void 0), (0, jsx_runtime_1.jsx)("path", { d: "M3 17h3M34 17h3M20 1v3M7.98 4.98L10.1 7.1M29.9 26.9l2.12 2.12M32.02 4.98L29.9 7.1M10.1 26.9l-2.12 2.12M17 36h6M18 39h4", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round" }, void 0)] }), void 0));
}
exports.default = SvgTips;
//# sourceMappingURL=Tips.js.map